<template>
  <div class="Choice" @mousedown="onClick()" @touchstart="onClick()">   
    <div ref="icon" class="Choice__icon" :class="indice">  
      <svg viewBox="0 0 68.68 64.57" v-if="indice == 'words'">
       <path class="cls-1" d="M7.1,14.59A7.1,7.1,0,0,0,0,21.69H23.58V64.57a7.1,7.1,0,0,0,7.1-7.1V14.59Z"/>
       <path class="cls-1" d="M38,64.57h.12a7,7,0,0,0,7-7V7.1H68.68A7.1,7.1,0,0,0,61.57,0H38Z"/>
       <path class="cls-1" d="M61.57,14.59H52.16v7.1H68.68A7.1,7.1,0,0,0,61.57,14.59Z"/>
       <path class="cls-1" d="M0,7.1H30.68V0H7.1A7.1,7.1,0,0,0,0,7.1Z"/>
      </svg>
      <svg  viewBox="0 0 68.94 76.9" v-if="indice == 'voice'">
        <path class="cls-1" d="M30.83,0H31a7.15,7.15,0,0,1,7.15,7.15V76.9a0,0,0,0,1,0,0H38a7.15,7.15,0,0,1-7.15-7.15V0a0,0,0,0,1,0,0Z"/>
        <path class="cls-1" d="M22.57,11.14h.13a0,0,0,0,1,0,0V58.6a7.15,7.15,0,0,1-7.15,7.15h-.13a0,0,0,0,1,0,0V18.3a7.15,7.15,0,0,1,7.15-7.15Z"/>
        <path class="cls-1" d="M53.4,11.14h.13a0,0,0,0,1,0,0V58.6a7.15,7.15,0,0,1-7.15,7.15h-.13a0,0,0,0,1,0,0V18.3a7.15,7.15,0,0,1,7.15-7.15Z"/>
        <path class="cls-1" d="M61.66,26.75h.13a7.15,7.15,0,0,1,7.15,7.15V50.15a0,0,0,0,1,0,0h-.13A7.15,7.15,0,0,1,61.66,43V26.75A0,0,0,0,1,61.66,26.75Z"/>
        <path class="cls-1" d="M0,26.75H.13A7.15,7.15,0,0,1,7.28,33.9V50.15a0,0,0,0,1,0,0H7.15A7.15,7.15,0,0,1,0,43V26.75a0,0,0,0,1,0,0Z"/>
      </svg>
    </div>

    <div ref="title" class="Choice__title">{{ indice }}</div>
    <div ref="description" class="Choice__description" v-html="trans('GLOBAL.share_'+ this.indice)"/>

    <!-- Enter a single word tocapture a lived experience -->

  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Choice',
  props: ['indice'],
  methods:{
    onClick() {

      // console.log(this.indice);

      gsap.timeline({
        onComplete: ()=>{
           this.$router.push({ params: { section: this.indice } })
        }
      })
      .to(this.$refs.icon, { duration: .25, scale: 0 })
      .to(this.$refs.title, { duration: .1, opacity: 0 })
      .add([ 
        gsap.to([this.$refs.icon, this.$refs.description, '.Choice'], { 
          duration: .25, 
          opacity: .0, 
          stagger:0.1 
        })
      ])
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Choice

  width 81%
  height 25vh
  // background rgb(118, 84, 191)
  // background linear-gradient(0deg, rgba(118, 84, 191, 1) 34%, rgba(147, 108, 207, 1) 100%)
  // margin 3vh 0

  background purple

  border-radius 8px
  display flex
  align-items center
  justify-content center
  flex-direction column
  font-size 22px
  cursor pointer

  & div   
    padding 4px

  &__icon
    transform-origin 50 50
    &.words 
      width 6vh
      height 6vh
    &.voice 
      width 6vh
      height 6vh

  &__title 
    text-transform capitalize
    font-size 22px
    font-family SpaceGrotesk
    font-weight 900

  &__description 
    font-size 16px
    line-height 20px
    font-family Raleway
    font-weight 400
    text-align center

    & span 
      font-weight 900

  .cls-1
    fill #fff

</style>


